/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Code_InvalidInputs */



/**
* | output |
* | --- |
* | "That code is wrong or expired. Check the email or request a new link." |
*
* @param {Login_Code_InvalidInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const login_code_invalid = /** @type {((inputs?: Login_Code_InvalidInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Code_InvalidInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Die code klopt niet of is verlopen. Kijk de e-mail na of vraag een nieuwe link.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce code est incorrect ou expiré. Vérifiez l'e-mail ou demandez un nouveau lien.")
	return /** @type {LocalizedString} */ ("That code is wrong or expired. Check the email or request a new link.")
});